import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import BackgroundVideo from "react-background-video-player";
import {rgba} from 'polished';
import firebase from 'firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import * as firebaseui from 'firebaseui'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

import './App.css';
import colors from "./template/utilities/colors";
import credentials from "./firebase/credentials";
import Footer from "./template/footer";
import spacings from "./template/utilities/spacings";
import Player from "./template/player";

const logo_source = "https://www.seo-usa.org/wp-content/uploads/2020/04/logo.png";
const video_source = "https://www.seo-usa.org/wp-content/uploads/2020/04/videoplayback.mp4";

const LoginWrapper = styled.div`
   display: flex;
   position: absolute;
   top: 0; left: 0; right: 0; bottom: 0;
   background: ${rgba(colors.primary, 0.8)};
   
   .login-box {
      width: 480px;
      background: ${colors.white};
      border-radius: 8px;
      box-shadow: 0px 3px 15px ${rgba(colors.black, 0.6)};
      padding: 20px;
      margin: 0 ${spacings.m};
      
      .logo {
        margin: 0 auto;
        width: 230px;
        height: 117px;
        background: url("${logo_source}");
        background-size: cover;
      }
      
      p {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: center;
      }
   }
`;

firebase.initializeApp(credentials);

function App() {

    const [user, loading, error] = useAuthState(firebase.auth());

    let url = new URL(window.location.href);
    const redirect_url = url.searchParams.append('autoclose', 'true');

    const uiConfig = {
        signInFlow: 'redirect',
        signInOptions: [
            {
                url: redirect_url,
                provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
                providerName: 'Send an access link to my email',
                requireDisplayName: true,
                forceSameDevice: false,
            },
            firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
        ],
        callbacks: {
            signInSuccessWithAuthResult: function signInSuccessFn(authResult, redirectUrl) {
                return false;
            }
        }
    };

    return (
        <div className="App">
            {
                ! user ? (
                    <div>
                        <BackgroundVideo
                            containerWidth={100}
                            containerHeight={100}
                            src={video_source}
                        />
                        <LoginWrapper className={'u-align-items-center u-justify-content-center'}>
                            <div className="login-box">
                                <div className="logo"></div>
                                <div>
                                    <p>
                                        We will send you an email with a link to access SEO 2020 Awards Dinner. You can also continue as a guest.
                                    </p>
                                    <StyledFirebaseAuth
                                        uiConfig={uiConfig}
                                        firebaseAuth={firebase.auth()}
                                    />
                                    <Footer marginTop={spacings.m} />
                                </div>
                            </div>
                        </LoginWrapper>
                    </div>
                ) : (
                    <Player
                        firebase={firebase}
                        user={user}
                        logout={() => firebase.auth().signOut()}
                    />
                )
            }
        </div>
    );
}

export default App;
